import { ObjectPermissionSetData } from 'types/permissions';
import { ResponseProps } from 'types/response';
import { http } from '.';

export enum PERMISSIONSAPI {
 GETBUILDERPERMISSION = '/permissions/permissionset/urldesigner/:cardId/:builderType/:published',
 SETBUILDERPERMISSION = '/permissions/permissionset/urldesigner/:cardId/permission',
}

export const getBuilderPermissions = (cardId: string, builderType: string, published: string) => http.get(PERMISSIONSAPI.GETBUILDERPERMISSION.replace(':cardId', cardId).replace(':builderType', builderType).replace(':published', published));
export const setBuilderPermissions = (cardId: string, permission: ObjectPermissionSetData) =>
 http.post<ResponseProps>(PERMISSIONSAPI.SETBUILDERPERMISSION.replace(':cardId', cardId), permission);
